import React from 'react';
import DatePicker from 'react-datepicker';

export class DateInput extends React.Component {
	render() {
		return (
			<DatePicker
				className="input"
				popperPlacement={this.props.popperPlacement}
				popperModifiers={
					this.props.popperModifiers
						? this.props.popperModifiers
						: DatePicker.popperModifiers
				}
				popperProps={this.props.popperProps}
				selected={this.props.value}
				onChange={newDate => this.props.onChange(newDate)}
				isClearable={true}
				maxDate={this.props.maxDate}
				showMonthYearPicker={this.props.isMonthYear ? true : false}
				dateFormat={
					this.props.isMonthYear
						? 'MMM yyyy'
						: this.props.isDateTime
							? 'dd/MM/yyyy h:mm aa'
							: 'dd/MM/yyyy'
				}
				showTimeSelect={this.props.isDateTime}
			/>
		);
	}
}
